<template>
  <div>
    <CottiChildPrivacy v-if="brand === 'COTTI'"/>
    <TeacatChildPrivacy v-else/>
  </div>
</template>

<script>
import CottiChildPrivacy from './components/cotti-child-privacy'
import TeacatChildPrivacy from './components/teacat-child-privacy'

export default {
  name: 'ChildPrivacy',
  components: {
    CottiChildPrivacy,
    TeacatChildPrivacy
  },
  data() {
    return {
      brand: ''
    }
  },
  mounted () {
    this.brand = this.$config.env.VUE_APP_BRAND
  }
  
}
</script>

<style scoped lang="scss">
</style>
